
export const DEFAULT_DROPDOWN_CONFIG: any = {
    highlight: false,
    create: false,
    persist: true,
    plugins: ['dropdown_direction', 'remove_button'],
    dropdownDirection: 'auto'
};

export const MULTI_SELECT_CONFIG: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'name',
    valueField: 'id',
    searchField: ['name'],
    plugins: ['remove_button'],
    minItems:1,
    maxItems: 1000
}); 

export const MULTI_SELECT_CONFIG_LANGUAGE: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'languageCultureName',
        valueField: 'languageCultureId',
        searchField: ['languageCultureName'],
        plugins: ['remove_button'],
        minItems:1,
        maxItems: 1000
    }); 

export const SINGLE_SELECT_CONFIG: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'name',
        valueField: 'id',
        searchField: ['name'], 
        plugins: ['remove_button'],
        maxItems: 1
    }); 

    export const MULTI_SELECT_CONFIG_PURCHASE_FLOW: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'name',
        valueField: 'id',
        searchField: ['name'],
        plugins: ['remove_button'],
        maxItems: 1000
});

export const MULTI_SELECT_CONFIG_PRODUCTS: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'name',
        valueField: 'id',
        searchField: ['name'],
        plugins: ['remove_button'],
        maxItems: 1000
});

export const  MULTI_SELECT_CONFIG_STATE: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'stateName',
    valueField: 'id',
    searchField: ['stateName'],
    plugins: ['remove_button'],
    minItems:1,
    maxItems: 1000
});

export const  DISTRIBUTIONCENTER_CONFIG_STATE: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'name',
    valueField: 'id',
    searchField: ['name'],
    plugins: ['remove_button'],
    minItems:1,
    maxItems: 100
});

export const SINGLE_SELECT_CONFIG_SHIPPING_ZONE: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'name',
    valueField: 'id',
    searchField: ['name'],
    plugins: ['remove_button'],
    minItems:1,
    maxItems: 1
}); 

export const MULTI_SELECT_CONFIG_SHIPPING_ZONE: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
    labelField: 'name',
    valueField: 'id',
    searchField: ['name'],
    plugins: ['remove_button'],
    minItems:1,
    maxItems: 1000
}); 

export const  MULTI_SELECT_CONFIG_FIELD: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'fieldName',
        valueField: 'id',
        searchField: ['fieldName'],
        plugins: ['remove_button'],
        minItems:1,
        maxItems: 100
    });


// WEBPACK FOOTER //
// ./src/app/customerservice/selectize/selectize.config.ts